import { TaskCard } from '@medely/ui-kit';
import React from 'react';
import { TaskCardLayout } from './TaskCard';
import { useProNavigate } from '../../contexts';

export type ProPoolOrientationProps = {
  locationName: string;
  poolId: number;
  positionNames: string[];
  shiftType: string;
  onTrackClick?: () => void;
};

export const ProPoolOrientation = ({
  locationName,
  onTrackClick,
  positionNames,
  shiftType,
  poolId,
}: ProPoolOrientationProps) => {
  const { navigate } = useProNavigate();

  const goToOrientationJobs = () => {
    if (onTrackClick) {
      onTrackClick();
    }

    navigate('OrientationJobsList', { poolId });
  };

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'users-medical', color: 'tertiary' }}
        title="Pro Pool orientation"
        body={`Schedule your ${positionNames.join(', ')} ${getShiftTypeText(
          shiftType,
        )} shift at ${locationName}.`}
        onClick={goToOrientationJobs}
      />
    </TaskCardLayout>
  );
};

// Currently only 'general' is supported as it is BE hard-coded, but this allows for future expansion
const getShiftTypeText = (shiftType: string) => {
  switch (shiftType) {
    case 'general':
      return 'General Orientation';
    default:
      return 'General Orientation';
  }
};
